import { getInfCLogger } from '@infodata-group/inf-commons-core';
import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { CookieService } from '@infodata-group/inf-commons';

const logger = getInfCLogger('HttpStatusUnauthorizedInterceptor');

@Injectable()
export class HttpStatusUnauthorizedInterceptor implements HttpInterceptor {
  constructor(private _cookieService: CookieService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && error.statusText === 'token expired') {
          logger.debug(`Cookie cleared`);
          // this._cookieService.clear(environment.domain);
          // Todo :: check if ok
          this._cookieService.clear();
          document.cookie.split(';').forEach(function (c) {
            document.cookie = c
              .replace(/^ +/, '')
              .replace(
                /=.*/,
                '=;expires=' + new Date().toUTCString() + ';path=/',
              );
          });
        }
        return throwError(() => error);
      }),
    );
  }
}
